import React from "react";
import Modal from "react-responsive-modal";
import "./styles.css";

export const NotificationToaster = ({ type, message, isOpen }) => (
  <Modal
    open={isOpen}
    center
    focusTrapped={false}
    closeOnOverlayClick={false}
    showCloseIcon={false}
    blockScroll={false}
    animationDuration={1500}
    classNames={{
      modal: `notification__modal notification__modal-${type}`,
      overlay: "notification__overlay",
      transitionEnter: "notification-enter",
      transitionEnterActive: "notification-enter-active",
      transitionExit: "notification-leave",
      transitionExitActive: "notification-leave-active",
    }}
    onClose={() => {}}
  >
    <div className="notification">
      <div className={`notification__logo icon-${type}`} />
      <p className="notification__description">{message}</p>
    </div>
  </Modal>
);
